import { Colors } from '@sigma-frontend-libs/commons'

import { getFile, getStorageURL } from '@/utils'

import { fileInfo } from '@/components/services/report-manager/queue/utils'

import render from './render'

export default {
  name: 'Item',

  mixins: [ getFile, fileInfo ],

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    showInfo: {
      type: Boolean,
      default: false
    },

    compact: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      buttonCallback: false
    }
  },

  computed: {
    labelColor() {
      if (this.hasLocks) {
        return Colors.grey
      }

      return Colors.error
    }
  },

  methods: {
    download(event) {
      if (this.file?.id && !this.buttonCallback) {
        event?.stopPropagation()
        window.location.href = getStorageURL([ this.file.id ])
        this.buttonCallback = true
        setTimeout(() => {
          this.buttonCallback = false
        }, 1000)
      }
    }
  },

  render
}
